import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../../hooks/hooks';
import { deepCopy } from '../../../../../common/services/common.service';
import { settings } from '../../../../../redux/settings/actions';
import PageLoader from '../../../../../components/PageLoader';
import { selectCurrent } from '../../../../../redux/settings/selectors';
import { selectCategoriesListItems } from '../../../../../redux/categories/selector';
import { categories } from '../../../../../redux/categories/action';
import { products } from '../../../../../redux/products/action';
import { selectListItems } from '../../../../../redux/library/selector';
import * as R from 'ramda'
import { selectOrganizationUnitsListItems } from '../../../../../redux/organizationUnits/selector';
import { selectTenantFunctionsListItems } from '../../../../../redux/tenant-functions/selector';
import { tenantFunctions } from '../../../../../redux/tenant-functions/action';
import { websites } from '../../../../../redux/websites/action';
import { accountWebPages } from '../../../../../redux/web-pages/action';
import { selectWebsitesListItems } from '../../../../../redux/websites/selector';
import { selectAccountWebPagesListItems } from '../../../../../redux/web-pages/selector';
import { accounts } from '../../../../../redux/accounts/action';
import { selectAccountsListItems } from '../../../../../redux/accounts/selector';
import { organizationUnits } from '../../../../../redux/organizationUnits/action';
import { selectProductsListItems } from '../../../../../redux/products/selector';
import { selectTemplatesListItems } from '../../../../../redux/templates/selector';
import storePersist from '../../../../../redux/storePersist';
import HelpTopicComponent from '../components/help-topic.component';
import { selectHelpTopicsQueryItem } from '../../../../../redux/help-topics/selector';
import { helpTopics } from '../../../../../redux/help-topics/action';

let currentChange: any = {}
const ManagementHelpTopic = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector((selectHelpTopicsQueryItem))
  const { getUploadFiles } = useAppSelector(selectCurrent)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const categoriesLists = useSelector(selectCategoriesListItems)
  const productsLists = useSelector(selectProductsListItems)
  const organizationUnitsLists = useSelector(selectOrganizationUnitsListItems)
  const tenantfunctionsLists = useSelector(selectTenantFunctionsListItems)
  const channelLists = useSelector(selectListItems)
  const templatesItems = useSelector(selectTemplatesListItems)
  const websitesItems = useSelector(selectWebsitesListItems)
  const webPagesItems = useSelector(selectAccountWebPagesListItems)
  const accountItems = useSelector(selectAccountsListItems)
  const librariesItems = storePersist?.get("library")?.current;
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    selectedHelpTopics,
    setSelectedHelpTopics
  ] = useState<any>({
    BodyContent: '',
    DesignFileurls: [],
    Attachmenturls: [],
    MappedEntities: []
  })
  const [
    selectedFunctions,
    setSelectedFunctions
  ] = useState<any>([])




  const [
    mediaFiles,
    setMediaFiles
  ] = useState<any>([])
  const fetchHelpTopicsId = () => {
    dispatch(helpTopics.query({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/help-topics/query`, entity: 'helpTopics', jsonData: {

        Records: [
          {


            "Id": parmas?.id



          }
        ]

      }
    })).then(() => {
      setIsQuery(true)
    }).then(() => {
      setIsLoading(false)
    })
  }

  useEffect(
    () => {
      dispatch(websites.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`, entity: 'cards', jsonData: {
        }
      })).then(() => {
        dispatch(accountWebPages.list({
          url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-pages/accounts/list`, entity: 'accountWebPages', jsonData: {
          }
        }))
      }).then(() => {
        dispatch(categories.list({
          url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/catalog/categories/list`,
          entity: 'categories',
          jsonData: {

          }
        }))
      }).then(() => {
        dispatch(products.list({
          url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/catalog/products/list`,
          entity: 'products',
          jsonData: {
          }
        }))
      }).then(() => {
        dispatch(accounts.list({
          url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/rms/accounts/fetch`,
          entity: 'accounts',
          jsonData: {
            Context: {},
            Records: [
              {
                IsProxyAccount: false
              }
            ],
            Pagination: {
            }

          }
        }))
      }).then(() => {
        dispatch(tenantFunctions.list({
          url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/functions/list`, entity: 'tenantDomainFunctions', jsonData: {
            Filters: [
              {
                FieldName: 'IsTemplateMappingEnabled',
                FieldText: 'TemplateMappingEnabled',
                FieldType: 'boolean',
                FilterOperatorId: 1,
                FieldValue: true
              }
            ]


          }
        }))
      })
      dispatch(organizationUnits.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/organization-units/list`, entity: 'organizationUnits', jsonData: {

        }
      }));
      if (parmas?.id > 0) {
        fetchHelpTopicsId()
        setIsLoading(false)
      }
      else {
        const localSelectedFunction = addNewRow({ selectedFunctionArg: selectedFunctions });
        setSelectedFunctions(localSelectedFunction)


        setIsLoading(false)
      }
    },
    []
  )


  useEffect(
    () => {

      if (isQuery) {
        setSelectedHelpTopics(queryItems?.result?.items)
        const localSelectedService = addNewRow({ selectedFunctionArg: queryItems?.result?.items?.MappedEntities });
        setSelectedFunctions(localSelectedService)


      }
    },
    [isQuery]
  )
  const handleFormAttachmentItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(mediaFiles);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setMediaFiles(items);
  }

  // media handle form change
  const handleFormMediaItemChange: any = ({ value }: any) => {
    setMediaFiles(value);
  }

  const deleteSelectedFunctions = async (Item: any, index: any) => {
    if (Item.Id === 0) {
      selectedFunctions?.splice(
        index,
        1
      )
    }
    handleClose()
  }
  const addNewRow = ({ selectedFunctionArg }: any) => {
    const localSelectedFunction = deepCopy(selectedFunctionArg)
    const newsFunctions = {
      Id: 0,
      OwnerTypeId: 0,
      OwnerId: 0,


    }
    if (localSelectedFunction.length === 0 ||
      localSelectedFunction[localSelectedFunction?.length - 1]?.OwnerTypeId !== 0 ||
      localSelectedFunction[localSelectedFunction?.length - 1]?.OwnerId !== ''
    ) {
      localSelectedFunction?.push(newsFunctions)
    }

    return localSelectedFunction
  }
  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedHelpTopics({ ...selectedHelpTopics, [field]: event });
  }
  const handleFormItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(selectedFunctions);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setSelectedFunctions(items);
  }







  const handleClose = () => {
    dispatch(settings.set({ getUploadFiles: 'close' }))

  }

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    selectedHelpTopics.IsApproved = true;
    selectedFunctions.splice(
      selectedFunctions.length - 1,
      1
    );
    mediaFiles?.splice(
      mediaFiles.length - 1,
      1
    )

    const mediaData: any = mediaFiles?.map((item: any) => {
      const itemData = {
        attachementURL: item?.FileMappingURL
      }
      return itemData
    })

    selectedHelpTopics.Attachmenturls = mediaData.map((data: any) => data.attachementURL);

    selectedHelpTopics.MappedEntities = selectedFunctions
    if (parmas?.id > 0) {
      await dispatch(helpTopics.resetAction({ actionType: 'update' }))
      await dispatch(helpTopics.update({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/help-topics`, entity: 'helpTopics',
        jsonData: {
          Records: [
            selectedHelpTopics
          ]
        }
      })).then(() => {
        back()
      })
    } else {
      await dispatch(helpTopics.resetAction({ actionType: 'create' }))
      await dispatch(helpTopics.create({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/help-topics`, entity: 'helpTopics', jsonData: {
          Records: [
            selectedHelpTopics
          ]
        }
      })).then(() => {
        back()
      })
    }
  }

  const setCombinationInfo = async () => {
    let localSelectedFunction = deepCopy(selectedFunctions)
    localSelectedFunction.splice(
      currentChange.idx,
      1,
      { ...localSelectedFunction[currentChange.idx] }
    );
    localSelectedFunction = addNewRow({ selectedFunctionArg: localSelectedFunction });
    currentChange.field = 'OwnerTypeIdDONE'
    setSelectedFunctions(localSelectedFunction)
  }

  useEffect(
    () => {
      if (currentChange.field === 'OwnerId') {
        setCombinationInfo()
      }
    },
    [selectedFunctions]
  )
  const back = () => {
    navigate('/management/cms/help-topics')
  }

  useEffect(() => {

  }, [selectedHelpTopics]
  )


  const formatWebpagesListData = (data: any) => {
    return _.map(data, (product: any) => {
      const item = {
        Id: product?.Id,
        WebpageName: `${product?.Name} : ${product?.AccountName}`,
      };
      return item
    });
  };
  return (
    <>

      {isLoading ? <PageLoader /> :
        <HelpTopicComponent
          handleInnerFormChange={handleInnerFormChange}
          back={back}
          handleFormSubmit={handleFormSubmit}
          selectedHelpTopics={selectedHelpTopics}
          HelpTopicType={librariesItems?.HelpTopicType}
          selectedFunctions={selectedFunctions}
          categories={categoriesLists?.result?.items}
          accounts={accountItems?.result?.items}
          channels={channelLists?.result?.items}
          organizationUnits={organizationUnitsLists?.result?.items}
          onFormItemChange={handleFormMediaItemChange}
          id={parmas?.id}
          products={productsLists?.result?.items}
          handleFormItemChange={handleFormItemChange}
          deleteSelectedFunctions={deleteSelectedFunctions}
          tenantFunction={tenantfunctionsLists?.result?.items}
          templates={templatesItems?.result?.items}
          mediaFiles={mediaFiles}
          handleFormAttachmentItemChange={handleFormAttachmentItemChange}
          websites={websitesItems?.result?.items}
          webpages={formatWebpagesListData(webPagesItems?.result?.items)}
          tenantFunctions={(tenantfunctionsLists?.result?.items || []).flatMap(
            (func: any) =>
              (func.Entities || []).map((entity: any) => ({
                label: entity.EntityName,       // what to show in dropdown
                value: entity.Id,               // OwnerTypeId
                FunctionName: func.FunctionName, // used for conditional logic
              })))}

        />}
    </>
  )

}

export default ManagementHelpTopic;